{
  "defaultAuthor": "Membro Xtreed",
  "errors": {
    "accessToken": "Não foi possível gerar o acesso.",
    "signIn": "Não foi possível entrar na comunidade.",
    "noResponse": "A comunidade não respondeu."
  },
  "miniPlayer": {
    "size": "Tamanho do vídeo",
    "sizeValue": "{{width}} pixels de largura",
    "position": "Posição do vídeo — use as setas para mover",
    "lesson": "Aula",
    "backToLesson": "Voltar para a aula"
  },
  "nav": {
    "loading": "Carregando espaços da comunidade",
    "loadError": "Não foi possível carregar os espaços da comunidade. Tente recarregar a página.",
    "empty": "Nenhum espaço disponível para você por enquanto.",
    "label": "Espaços da comunidade",
    "postCount_one": "{{count}} publicação",
    "postCount_zero": "{{count}} publicações",
    "postCount_other": "{{count}} publicações",
    "lessonTag": "Aula",
    "locked": "Espaço bloqueado"
  },
  "list": {
    "pinned": "Fixado",
    "special": {
      "lockedTitle": "Espaço restrito",
      "calendarTitle": "Espaço de agenda",
      "materialsTitle": "Espaço de materiais",
      "lockedDescription": "Você ainda não tem acesso a este espaço. Ele deve ser aberto na comunidade.",
      "unsupportedDescription": "Este tipo de espaço não abre aqui dentro da aula — abra a comunidade para ver o conteúdo completo."
    },
    "empty": {
      "title": "Nenhuma conversa por aqui ainda",
      "description": "Comece você: publique a dúvida da aula ou mostre o que acabou de criar."
    },
    "unavailable": "Espaço indisponível.",
    "postFooter": "_Publicado a partir da aula [{{title}}]({{url}})._",
    "published": "Publicado!",
    "conversations_one": "{{count}} conversa",
    "conversations_zero": "{{count}} conversas",
    "conversations_other": "{{count}} conversas",
    "compose": {
      "titlePlaceholder": "Título da publicação",
      "bodyPlaceholder": "Conte o que está acontecendo, cole o código, descreva o erro...",
      "cancel": "Cancelar",
      "publish": "Publicar",
      "publishIn": "Publicar em {{space}}"
    }
  },
  "conversation": {
    "removedAuthor": "Removido",
    "replied": "Respondido!",
    "none": {
      "title": "Nenhuma conversa aberta",
      "description": "Escolha uma conversa na lista para ler a discussão inteira e responder por aqui."
    },
    "loadError": {
      "title": "Não foi possível carregar esta conversa",
      "description": "Pode ser uma queda momentânea da comunidade. Tente abrir de novo em instantes."
    },
    "reactWith": "Reagir com {{emoji}}",
    "replies": "Respostas",
    "noReplies": "Ninguém respondeu ainda. Sua resposta pode ser a primeira.",
    "yourReply": "Sua resposta",
    "replyPlaceholder": "Escreva sua resposta…",
    "markdownHint": "Markdown simples funciona aqui.",
    "reply": "Responder",
    "closed": "Esta conversa não está aceitando novas respostas."
  },
  "dock": {
    "community": "Comunidade",
    "someone": "Alguém",
    "replies_one": "{{count}} resposta",
    "replies_zero": "{{count}} respostas",
    "replies_other": "{{count}} respostas",
    "openPrompt": "Abra para conversar com a turma",
    "label": "Comunidade Xtreed",
    "back": "Voltar",
    "showSpaces": "Ver espaços da comunidade",
    "openFull": "Abrir completa",
    "backToLesson": "Voltar para a aula",
    "spaces": "Espaços",
    "closeSpaces": "Fechar espaços"
  }
}
